<template>
  <div v-if="!isHomePage" class="custom-navbar" :class="isOtherNavbar ? 'navbar-central' : ''">
    <VanNavBar :title="title" :fixed="true" :left-arrow="showLeftArrow" placeholder clickable @click-left="onBack">
      <template v-if="isRecord || isDados" #right>
        <div v-if="isRecord" class="record-img" @click="changePage">
          <img src="@/assets/record.png" />
        </div>
        <div v-if="isDados" class="navbar-action-text" @click="handleRight">
          {{ t('profile-index.common.save') }}
        </div>
      </template>
    </VanNavBar>
  </div>
</template>

<script setup>
import { rootRouteList } from '@/config/routes'
import emitter from '@/utils/eventBus'
const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const isHomePage = computed(() =>
  [
    'Home',
    'Activity',
    'Deposito',
    'Profile',
    'game-id',
    'Saque',
    'Registros',
    'vendorearch',
    'Games',
    'Roleta',
    'SaquesTarefas',
    'SaquesApostasDetalhes',
    'Lottery-BlindBoxes-iPhone17',
    'Land',
  ].includes(route.name)
)
const isRecord = computed(() => ['WithdrawalHistory', 'DepositHistory'].includes(route.name))

const isDados = computed(() => {
  return ['UserInfo'].includes(route.name)
})

const isOtherNavbar = computed(() => ['AccountCenter'].includes(route.name))
/**
 * Get page title
 * Located in src/locales/json
 */
const title = computed(() => {
  const i18nTitleKey = route.meta?.i18nTitleKey

  if (typeof i18nTitleKey === 'string' && i18nTitleKey) {
    return t(i18nTitleKey)
  }

  if (route.name) {
    return t(`navbar-index.navbar.${String(route.name)}`)
  }

  return t('navbar-index.navbar.Undefined')
})

/**
 * Show the left arrow
 * If route name is in rootRouteList, hide left arrow
 */
const showLeftArrow = computed(() => {
  if (route.name && rootRouteList.includes(route.name)) {
    return false
  }

  return true
})

function onBack() {
  try {
    if (window.history.state.back) {
      history.back()
    } else {
      router.replace('/')
    }
  } catch (error) {
    window.location.href = '/'
  }
}

function changePage() {
  if (route.name == 'DepositHistory') {
    router.push({ name: 'WithdrawalHistory' })
  } else {
    router.back()
  }
}

const handleRight = () => {
  emitter.emit('navbar-click-right')
}
</script>
<style lang="less" scoped>
.custom-navbar {
  position: relative;
  z-index: var(--navbar-z-index, 1999);

  :deep(.van-nav-bar--fixed) {
    z-index: var(--navbar-z-index, 1999) !important;
  }

  :deep(.van-nav-bar__placeholder) {
    z-index: var(--navbar-z-index, 1999);
  }

  :deep(.van-hairline--bottom:after) {
    border-width: 0 !important;
  }
}

.navbar-central {
  :deep(.van-nav-bar) {
    background: linear-gradient(to right, #49c755, #0f9957) !important;
  }
}
.record-img {
  width: 17.5px;
}

.navbar-action-text {
  font-size: 14px;
  color: var(--navbar-action-text-color, var(--color-10002));
}
</style>
